<template>
  <v-container id="kidGifts" fluid>
    <v-row>
      <v-col md="12" cols="12">
        <v-card flat tile>
          <v-card-title>
            <v-row align="center">
              <v-col cols="12" md="12" class="d-flex justify-md-start justify-center">
                <div class="heading-h3">Rewards</div>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-subtitle>
            <p>
              Check out your kid's rewards and wishlist.
            </p>
          </v-card-subtitle>

          <KidGiftsInfoTabs class="px-4"/>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import KidGiftsInfoTabs from "@/components/Kids/KidGiftsInfoTabs";

  export default {
    name: "kidGifts",

    data() {
      return {
        kid: {},
      };
    },

    computed: {
      isParent() {
        return this.$store.getters.userInfo.role === "parent";
      },
    },

    components: { KidGiftsInfoTabs },

    created() {
      if (this.isParent) {
        this.$store.commit("setLoadingStatus", true);

        this.$http
          .get(`/children/${this.$route.params.id}`)
          .then((response) => {
            //TODO move this into Vuex module
            this.kid = response.data.child;

            this.$store.commit("addWishes", response.data.wishes);
            this.$store.commit("setLoadingStatus", false);
          })
          .catch((error) => {
            console.error(error);
            this.$store.commit("setError", {
              message: "Could not retrieve kid's profile, please try again later",
              type: "error",
            });
            this.$store.commit("setLoadingStatus", false);
          });
      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Kids/KidGifts.vue